module.exports = __webpack_public_path__ + "img/_germany.a3554eb6.png";